import { render, staticRenderFns } from "./CalendarOrders.vue?vue&type=template&id=2c48806f&scoped=true"
import script from "./CalendarOrders.vue?vue&type=script&lang=js"
export * from "./CalendarOrders.vue?vue&type=script&lang=js"
import style0 from "./CalendarOrders.vue?vue&type=style&index=0&id=2c48806f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c48806f",
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fgithub%2Fworkspace%2Fsrc%2Fviews%2Fcalendar-orders%2FCalendarOrders.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports